import { Container, Stack, Heading, SimpleTabs } from '@/components/lib'
import useStore from '../../store'
import useTitle from '../../hooks/useTitle'
import Login from '../entry/Login'
import Profile from './Profile'
// import Notifications from './Notifications'
import Account from './Account'
import Password from './Password'
import Appearance from './Appearance'

export default function Settings () {
  useTitle('Settings')
  const { user } = useStore()

  if (!user) return <Login withWarning />
  return (
    <Container>
      <Stack gap={5}>
        <Heading as='h2' size='lg'>Manage your account</Heading>
        <SimpleTabs
          tabs={[
            { title: 'Profile', to: '/settings/profile', content: <Profile /> },
            { title: 'Appearance', to: '/settings/appearance', content: <Appearance /> },
            /* { title: 'Notifications', to: '/settings/notifications', content: <Notifications /> }, */
            { title: 'Account', to: '/settings/account', content: <Account /> },
            { title: 'Password & two-factor', to: '/settings/security', content: <Password /> }
          ]}
        />
      </Stack>
    </Container>
  )
}
